var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('MainHeader'),_c('MainNav',{on:{"nav-data":_vm.getNavData}}),_c('div',{staticClass:"iv-home-content"},[_c('router-view',{attrs:{"navData":_vm.navData}})],1),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }